import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footerLinksContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '0.5em',
  },
  footerLinkListItem: {
    width: 'auto',
  },
  copyrightContainer: {
    display: 'flex',
  },
  divider: {
    alignSelf: 'center',
    height: '1em',
    margin: 'auto 0.5em',
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useStyles;
